import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefRankingOrigin } from './interface/IRefRankingOrigin';

@Entity('ref_ranking_origin')
export class RefRankingOrigin extends BaseEntity implements IRefRankingOrigin{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
